export class PartnershipFactory {
    static create(partnership: IPartnership): IContentAPIPartnership {
        return new Partnership(partnership).serialize();
    }
}

export class Partnership {
    protected _code: string;

    constructor(partnership: IPartnership) {
        this._code = partnership.code;
    }

    serialize(): IContentAPIPartnership {
        const partnership: IContentAPIPartnership = {
            code: this._code
        };

        return partnership;
    }
}

export interface IContentAPIPartnership {
    code: string;
}
